import React from "react";
import Separator from "@/components/misc/Separator";
import TestimonialsCard from "@/components/testimonials/testimonialsCard";

const TestimonialsList = () => {
  return (
    <>
      <Separator
        text={window.post_template.checkout_v4_testimonials.tr_checkout_v4_testimonials_section_title}
        margin="24px 0px 16px"
        dataTestid="testimonials-title"
      />
      <div data-testid="testimonials-container" className="testimonials__container">
        {window.post_template.checkout_v4_testimonials.checkout_v4_testimonials_reviews &&
          window.post_template.checkout_v4_testimonials.checkout_v4_testimonials_reviews.map((testimonial, index) => (
            <TestimonialsCard testimonial={testimonial} key={index} />
          ))}
      </div>
    </>
  );
};

export default TestimonialsList;
